import React from 'react';
import classNames from 'classnames';
import vipBadge from './vip-badge.png';
import vipBadgeBlack from './vip-badge-black.png';
import styles from './index.module.scss';

interface VipBadgeProps {
  className?: string;
  variant?: 'default' | 'black';
}

function getImageSrc(asset: unknown): string {
  if (typeof asset === 'string') return asset;
  if (asset && typeof asset === 'object') {
    const imageAsset = asset as { src?: string; default?: string | { src?: string; }; };
    if (typeof imageAsset.src === 'string') return imageAsset.src;
    if (typeof imageAsset.default === 'string') return imageAsset.default;
    if (imageAsset.default && typeof imageAsset.default === 'object' && typeof imageAsset.default.src === 'string') {
      return imageAsset.default.src;
    }
  }
  return '';
}

export default function VipBadge({ className, variant = 'default' }: VipBadgeProps) {
  const badge = variant === 'black' ? vipBadgeBlack : vipBadge;
  const src = getImageSrc(badge);
  if (!src) return null;
  return (
    <img
      src={src}
      alt="VIP"
      className={classNames(styles.vipBadge, className)}
      aria-label="VIP"
    />
  );
}
